import {createActions} from 'client/framework';

const normalActions = [
  'RESET_STORE',
  'SET_ACTIVE_SUBJECT',
  'SET_BACK_BUTTON_PATH',
  'SET_SCROLL_POSITION'
];

export const subjectViewActions = createActions(null, normalActions);
